import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const RehomeConfirmDialog: React.FC<Props> = ({
  open,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation('calibration');

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        {t('runPage.rehomeTitle', { defaultValue: 'Re-home robot' })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('runPage.rehomeBody', {
            defaultValue:
              'Run the station power-up and homing sequence now. Make sure the bed is clear and no DMM is held before continuing.'
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t('runPage.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t('runPage.rehomeConfirm', { defaultValue: 'Re-home now' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RehomeConfirmDialog;
